/**
 * This class holds information about the customer
 */
import { Country } from "@/types/Country";

export class Customer {
  first_name: string = "";
  last_name: string = "";
  state: Country = new Country();
  different_user: boolean = false;
}
